<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <!-- <v-flex xs12 sm6 md2>
           <v-text-field @keyup.enter="search_client_by_code"  v-model="searchClientCode" label="كودالعميل"  ></v-text-field>
            </v-flex> 
             <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_client"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="أختر العميل"
                    persistent-hint
                    return-object
                    single-line
                    @change="get_all_info"
                ></v-select>
                  </v-flex> -->
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_khazna"
            :items="khazinas"
            item-text="name"
            item-value="id"
            label="  أختر الخزينة من"
            persistent-hint
            return-object
            single-line
            @change="get_khazina"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_khazna2"
            :items="khazinas"
            item-text="name"
            item-value="id"
            label="  أختر الخزينة الي"
            persistent-hint
            return-object
            single-line
            @change="get_khazina"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="money"
            type="number"
            label="المبلغ"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md1>
          <v-text-field
            v-model="select_khazna.rasid"
            disabled
            type="number"
            label="رصيد خزينة من "
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-textarea v-model="comment" rows="2" label="ملاحظات"></v-textarea>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="add_khazinaTransfer">تحويل</v-btn>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.price_after }}</td>
          <td class="text-xs-right">{{ props.item.remain }}</td>
          <td class="text-xs-right">{{ props.item.sdad_status }}</td>
          <td class="text-xs-right">{{ props.item.sdad_type_name }}</td>
          <td class="text-xs-right">{{ props.item.taslim_date }}</td>
          <td class="text-xs-right">{{ props.item.madionia_now }}</td>
          <td class="text-xs-right">
            <v-text-field
              v-model="props.item.money"
              type="number"
              @keyup.enter="add_khasm(props.item)"
            ></v-text-field>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير غير مسددة</div>
    </v-container>
  </div>
</template>

<script>
import {
  clients,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  khazinas,
  khazina_transfer_fatworas,
  khazna_fatworas,
  add_khazinaTransfer
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الكود",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " السعر", value: "address", sortable: false, align: "right" },
      { text: " المتبقي", value: "address", sortable: false, align: "right" },
      { text: " حالة السداد", value: "rasid", sortable: false, align: "right" },
      { text: " نوع السداد", value: "rasid", sortable: false, align: "right" },
      {
        text: "تاريخ التسليم",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "المديونية وقتها ",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " مبلغ الخصم ",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    select_client: { id: "" },
    select_khazna: { id: "" },
    select_khazna2: { id: "" },
    search: "",
    comment: "",
    loading: true,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    khazina_fatworas: [],
    clients: [],
    fatworas: [],
    khazinas: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",

    khazna_fatwora_table1: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      khazina_id: "",
      action: "",
      created_at: ""
    },
    khazna_fatwora_table2: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      khazina_id: "",
      action: "",
      created_at: ""
    },

    khazina1: {
      id: "",
      rasid: ""
    },
    khazina2: {
      id: "",
      rasid: ""
    }
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });

      let myUser = JSON.parse(localStorage.getItem("user"));
      khazinas(myUser.branch_id).then(response => {
        this.khazinas = response.data;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });
    },

    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_client.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_client.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_client.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina_transfer_fatworas(this.select_khazna.id).then(response => {
        this.theKhazna = response.data;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_khazinaTransfer() {
      if (
        this.money != "" &&
        this.select_khazna.id != "" &&
        this.select_khazna.id2 != ""
      ) {
        if (parseFloat(this.money) <= parseFloat(this.select_khazna.rasid)) {
          let myUser = JSON.parse(localStorage.getItem("user"));

          this.khazna_fatwora_table1.code = this.mycode;
          this.khazna_fatwora_table1.emp_name = myUser.name;
          this.khazna_fatwora_table1.rasid_before = this.select_khazna.rasid;
          this.khazna_fatwora_table1.money = this.money;
          this.khazna_fatwora_table1.rasid_after = parseFloat(this.money);
          this.khazna_fatwora_table1.type = "out";
          this.khazna_fatwora_table1.action = "transfer_from";
          this.khazna_fatwora_table1.notes = this.comment;
          this.khazna_fatwora_table1.khazina_id = this.select_khazna.id;
          this.khazna_fatwora_table1.created_at = this.date2;

          let khazina_fatwora_1 = JSON.stringify(this.khazna_fatwora_table1);

          this.khazna_fatwora_table2.code = this.mycode + 1;
          this.khazna_fatwora_table2.emp_name = myUser.name;
          this.khazna_fatwora_table2.rasid_before = this.select_khazna2.rasid;
          this.khazna_fatwora_table2.money = this.money;
          this.khazna_fatwora_table2.rasid_after = parseFloat(this.money);
          this.khazna_fatwora_table2.type = "in";
          this.khazna_fatwora_table2.action = "transfer_to";
          this.khazna_fatwora_table2.notes = this.comment;
          this.khazna_fatwora_table2.khazina_id = this.select_khazna2.id;
          this.khazna_fatwora_table2.created_at = this.date2;

          let khazina_fatwora_2 = JSON.stringify(this.khazna_fatwora_table2);

          this.khazina1.id = this.select_khazna.id;
          this.khazina1.rasid = this.money;
          let khazina_1 = JSON.stringify(this.khazina1);

          this.khazina2.id = this.select_khazna2.id;
          this.khazina2.rasid = this.money;
          let khazina_2 = JSON.stringify(this.khazina2);

          this.do_deposit(
            khazina_fatwora_1,
            khazina_fatwora_2,
            khazina_1,
            khazina_2
          );
        } else {
          this.$swal("Error", "الرصيد غير كافي ", "Error");
        }
      }
    },
    do_deposit(khazina_fatwora_1, khazina_fatwora_2, khazina_1, khazina_2) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("khazina1", khazina_1);
      frmData.append("khazina2", khazina_2);
      frmData.append("khazina_fatwora_1", khazina_fatwora_1);
      frmData.append("khazina_fatwora_2", khazina_fatwora_2);
      add_khazinaTransfer(frmData).then(response => {
        this.$router.go(0);
        this.loading = false;
      });
    },
    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
